import { useQuery } from '@tanstack/react-query'
import { ORDER_LIST_LIMIT, ORDERS_PAGE } from '../constants/orders'
import { QUERY_KEYS } from '../constants/query'
import { toApiMessage } from '../helpers/api-error'
import { fetchOrders } from '../helpers/orders-api'

export function useRecentOrders() {
  const ordersQuery = useQuery({
    queryKey: QUERY_KEYS.ordersList('all', ORDER_LIST_LIMIT),
    queryFn: () => fetchOrders({ limit: ORDER_LIST_LIMIT }),
  })
  const orders = ordersQuery.data ?? []
  const error = ordersQuery.error
    ? toApiMessage(ordersQuery.error, ORDERS_PAGE.loadError)
    : ''

  return {
    orders,
    loading: ordersQuery.isPending && !ordersQuery.data && !error,
    error,
  }
}
